import React from "react";
import * as Ons from "react-onsenui";
import { CaregiverPatientDocument, PatientDocumentScanCreate } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { Center } from "./Center";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "./Generic/AppCard";
import { ScheduledVisitReqDocsComponent } from "./ScheduledVisitReqDocsComponent";
import { InitialPlanOfCare } from "./useVisitInstancePlanOfCare";
import { VisitInstanceDocumentsAndPlanOfCareState } from "./VisitInstanceDocumentsAndPlanOfCareActivity";

interface Props {
  data: VisitInstanceDocumentsAndPlanOfCareState;
  onUploadFreeScan: (data: PatientDocumentScanCreate) => void;
  onDeleteFreeScan: (document: CaregiverPatientDocument.FreeScan) => void;
  onClickDocument: (document: CaregiverPatientDocument) => void;
  onClickPlanOfCare: (planOfCare: InitialPlanOfCare) => void;
}

const VisitInstanceDocuments = (props: Props) => {
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>{translate(STRINGS.REQUIRED_DOCUMENTS)}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        {props.data.type === "Loading" ? (
          <Center>
            <Ons.ProgressCircular indeterminate={true} />
          </Center>
        ) : (
          <ScheduledVisitReqDocsComponent
            documents={props.data.documents}
            planOfCare={props.data.planOfCare}
            isUploadingDocument={props.data.isUploadingDocument}
            onUploadFreeScan={props.onUploadFreeScan}
            onDeleteFreeScan={props.onDeleteFreeScan}
            onClickDocument={props.onClickDocument}
            onClickPlanOfCare={props.onClickPlanOfCare}
          />
        )}
      </AppCardContent>
    </AppCard>
  );
};

export default VisitInstanceDocuments;
